import { api } from "../../common/config/api";

export const SHOP_URL = {
	getShop: `${api.withAPI}/v1/shop`,
	createShop: `${api.withAPI}/v1/shop`,
	delete_shop: `${api.withAPI}/v1/shop`,
}